import api from '../api';
import { normalizePortalUser } from '../corporate/users';

function omitUserPassword(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    const body = { ...payload };
    delete body.password;
    delete body.repassword;
    delete body.rePassword;
    return body;
}

export default {
    async getDataUser(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/user`,  {
                headers,
            });
            return normalizePortalUser(response.data);
        } catch (error) {
            console.error('Erro ao carregar dado do aluno:', error);
                throw error;
        }
    },
    async EditUser(accessToken, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.put(`/portal/user`, omitUserPassword(payload), {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar dado do aluno:', error);
                throw error;
        }
    },
    async changePassword(accessToken, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/portal/change-password`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar senha', error);
                throw error;
        }
    },
    

}

